import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { RoutingService } from '../../angular-wallet-base/services/routing.service';
import { AppState, getUserStakingState } from '../../angular-wallet-base/store/appState';
import {
VestingLtcStateInitRequestAction,

} from "../../angular-wallet-base/actions/vestingLTC.actions";
import { OneInchService } from 'src/app/angular-wallet-base/services/one-inch.service';
import { ToastController, ModalController } from '@ionic/angular';
import { PinModalComponent } from 'src/app/components/pin-modal/pin-modal.component';
import { AUTH_REASON, TRADE_SLIPPAGE } from 'src/app/angular-wallet-base/constants';
import {
StakingLodeStateInitRequestAction,
ApproveStakingLodeStateAction,
StakeStakingLodeStateAction,
ClaimStakingLodeStateAction,
UnStakeStakingLodeStateAction,
LockLodeStateAction,
ApproveVoteStateAction
} from "src/app/angular-wallet-base/actions/stakingLode.actions";
import {
  getSingularitySession,
  getWalletConnectEventRequests,
  getWalletConnectInstance,
  getWalletConnectSelectedNetwork,
  getWalletConnectSession,
  IWalletConnectSelectedNetwork
} from "../../angular-wallet-base/store/walletConnect";

const assetsMap = {
  "0x68327a91E79f87F501bC8522fc333FB7A72393cb": "AUX",
  "0x13E7bceFddE72492E656f3fa58baE6029708e673": "AGX",
  "0x0000000000000000000000000000000000000000": "AVAX",
  "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E": "USDC"
}

@Component({
  selector: 'app-stake-lode-profile',
  templateUrl: './stake-lode.page.html',
  styleUrls: ['./stake-lode.page.scss'],
})


export class StakeLodePage implements OnInit {
  @ViewChild('popover') popover;
  public stakingUserInfo = {
      lodeBalance: null,
      hasApprovedLODE: false,
      hasApprovedVote: false,
      canLock: false,
      hasStaked: false,
      isLocked: false,
      stakingInfo: {
        stakingBalance: 0,
        lockedBalance: 0,
        lockDeadline: 0,
      },
  };
  public  message: string = null;
  public loading: boolean = true;
  public error: boolean = false;
  public isOpen:boolean = false;
  public  info: string = null;
  public loadingApprove: boolean = false;
  public loadingStake: boolean = false;
  public loadingUnstake: boolean = false;
  public loadingLock: boolean = false;
  public loadingApproveVote: boolean = false;
  public loadingClaim: boolean = false;
  public amount: number;
  public pin: string = null;
  public userWallet;
  public selectedNetwork;
  public claimInfo = [];

  constructor(
   private routingService: RoutingService,
   protected store: Store<AppState>,
   private toastController: ToastController,
   private modalCtrl: ModalController,
   private oneInchService: OneInchService,
  ) {
 

  }

  async ngOnInit() {
    await this.oneInchService.initiateConnection();
    await this.openPinModal(this.amount);
    this.store.dispatch(new StakingLodeStateInitRequestAction(this.userWallet.address));
    this.store.select(getUserStakingState).subscribe(res => {
      if(res) {
          this.stakingUserInfo = res.userStakingLode;
          this.claimInfo = res.userStakingLode.claimingInfo.map(item => ({
            asset: assetsMap[item.asset],
            balance: item.balance
          }))
          this.loading = res.loading;
          this.loadingApprove = false;
          this.loadingStake = false;
          this.loadingUnstake = false;
          this.loadingLock = false;
          this.loadingApproveVote = false;
          this.loadingClaim = false;
          this.error = res.error;
          this.message = res.message;
          if(this.message.length > 1) {
            this.presentToast(this.message, this.error);
          }
        }
    }) 
  }

  get totalClaimableBalance(): number {
    return this.claimInfo.reduce((sum, item) => sum + item.balance, 0);
  }

  async approveLODE() {
    this.loadingApprove = true;
    await this.store.dispatch(new ApproveStakingLodeStateAction(this.userWallet));
  }

  async claimAll() {
    this.loadingClaim = true;
    await this.store.dispatch(new ClaimStakingLodeStateAction(this.userWallet));
  }

  async lockAmount() {
    this.loadingLock = true;
    await this.store.dispatch(new LockLodeStateAction(this.userWallet, this.amount));
  }

  async approveVote() {
    this.loadingApproveVote = true;
    await this.store.dispatch(new ApproveVoteStateAction(this.userWallet));
  }

  async stakeLODE() {
    this.loadingStake = true;
    await this.store.dispatch(new StakeStakingLodeStateAction(this.userWallet, this.amount));
  }

  async unstakeLODE() {
    this.loadingUnstake = true;
    await this.store.dispatch(new UnStakeStakingLodeStateAction(this.userWallet, this.amount));
  }

  private async openPinModal(amount?: number): Promise<void> {
   const modal = await this.modalCtrl.create({
      component: PinModalComponent,
      backdropDismiss: false,
      cssClass: 'fullscreen-modal',
      componentProps: {
        reason: AUTH_REASON.STAKE_LODE,
        amount: this.amount
      },
      id: 'pinModal'
    });

    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.pin = data.pin;
    this.userWallet = await this.oneInchService.getWallet(this.pin);
  }

  async goBack() {
    await this.routingService.goHome();
  }
  
  handleAmountLode(e) {
     this.amount = e.detail.value;
  }

  handleAmountStake(e) {
    this.amount = e.detail.value;
  }

  handleLockAmount(e) {
    this.amount = e.detail.value;
  }

  handleUnstakeAmount(e) {
    this.amount = e.detail.value;
  }

  presentPopover(e: Event, action) {
    this.popover.event = e;
    this.isOpen = true;
    if (action === 'Claim') {
        this.info = 'This allows you to receive all your claimable balances on your vault wallet';
    } else if (action === 'Stake') {
        this.info = 'Place your LODE balance into a staking scheme, where you’ll be entitled to claimable rewards in many tokens';
    } else if (action === 'Unstake') {
        this.info = 'The staked LODE balance will exit the staking scheme and be deposited into your vault wallet as well as any claimable balances';
    } else if (action === 'Lock') {
        this.info = 'You can lock a share of the staked LODE balance for extra benefits. The minimum locking threshold is 10,000 LODE over a 3-month period';
    } else if (action === 'ApproveLODE') {
        this.info = 'You need to set an allowance on the LODE token to start staking your balance. This action is only required once';
    }
    else if (action === 'ApproveVOTE') {
        this.info = 'You need to set an allowance on the VOT3 token to be able to unstake the LODE balance. This action is only required once';
    }
  }

  bigInt(weiValue: bigint) {
    return parseFloat((Number(weiValue) / (10 ** 18)).toFixed(6))
  }

  async presentToast(message: string, error) {
    const toast = await this.toastController.create({
      message: message,
      color: error ? 'warning' : 'success',
      duration: 3000, // Duration in milliseconds
      position: 'top' // Position of the toast message
    });
    toast.present();
  }
}
